export default __webpack_public_path__ + "static/media/1.bb0359d7.jpg";